/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const CalendarIcon = props => {
	const { color = 'black' } = props

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			style={{
				enableBackground: 'new 0 0 24 24'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
		>
			<g>
				<path d='M19 2h-1V1c0-.6-.4-1-1-1s-1 .4-1 1v1H8V1c0-.6-.4-1-1-1S6 .4 6 1v1H5C2.2 2 0 4.2 0 7v12c0 2.8 2.2 5 5 5h14c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5zM2 7c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v1H2V7zm17 15H5c-1.7 0-3-1.3-3-3v-9h20v9c0 1.7-1.3 3-3 3z' />
				<circle cx={12} cy={15} r={1.5} />
				<circle cx={7} cy={15} r={1.5} />
				<circle cx={17} cy={15} r={1.5} />
			</g>
		</svg>
	)
}

export default CalendarIcon
